__turbopack_context__.v({
  "h1": "styleConstants-module__UmNYqG__h1",
  "sectionPadding": "styleConstants-module__UmNYqG__sectionPadding",
});
